export default {
  primaryColor: "#e7f3ff",
  activeBarColor: "#f2f4fa",
  buttonColor: "#e7f3ff",
  buttonTextColor: "#043077",
  backgroundColor: "#f9fafb",
  onHover: "#e5f5fe",
  btnTextColor_new: "#366ff4",
  fileUrl: "https://server.uraudits.com/view?Key=",
  version: "1.3",

  // New Components
  globalColor1: "#043077", //Small Heading Color
  globalColor2: "#434343", //Main Heading Color
  globalColor3: "#434343", //Sub Heading Color
  globalColor4: "#e5ecef", //Input Border Color
  globalColor5: "#f7f9fb", //Input Feild Background color
  globalColor6: "#c6c7c9", //Input Place Holder Color
  globalColor7: "#555556", //Input feild Visible color
  globalColor8: "#043077", //Button Color (main theme color)
  globalColor9: "#eaf7fe", //BackgroundColor green 
};
